import dayjs from 'dayjs';

/**
 * Gets the current time, subtracts 5 minutes to prevent backend errors, and formats it as 'HH:mm'.
 *
 * @returns {string} The formatted time string in 'HH:mm' format.
 *
 * @example
 * // Returns the current time minus 5 minutes, formatted as 'HH:mm'
 * const time = currentTime();
 * console.log(time); // e.g., "14:25"
 *
 * @dependencies
 * This function depends on the `dayjs` library for date manipulation and formatting.
 */
export function currentTime() {
  const current = dayjs();
  // Remove 5 minute to prevent error from backend
  const updatedTime = current.subtract(5, 'minute');
  const formattedTime = updatedTime.format('HH:mm');
  return formattedTime;
}
